import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import ScrollAnimation from 'react-wow';
import Link from 'next/link';

export default class index extends Component {
    render() {
        return (
            <section className="devalopement-sec">
                <Container>
                    <div className="mt-sm-4 mb-4 pt-4 pb-4">
                        <Row>
                        <Col className="text-center mobile">
                                <ScrollAnimation animation='bounceInRight'>
                                    <img src={`${publicRuntimeConfig.staticFolder}/images/ux-ui-sec.png`} alt="ux-ui-sec" className="mt-3 auto-width-c" />
                                </ScrollAnimation>
                            </Col>
                            <Col md>
                                <ScrollAnimation animation='bounceInLeft'>
                                    <div className="pl-sm-3">
                                        <div className="mt-sm-4 pt-4">
                                            <div className="count">02</div>
                                            <div className="talk-content count-sd pl-3">What we do?</div>
                                        </div>
                                        <div className="main-heading-home pt-2">UX/UI Design</div>
                                        <div className="main-content pt-1">
                                             Usability, simplified. Visibility, magnified. We emphasize on elegant, yet functional designs that fulfill a user's needs.
                                        </div>
                                        <Link href="/ui-ux-design-services" as="/UX-UI-Design">
                                                <div className="talk-content explore mt-5">Explore
                                                   <img src={`${publicRuntimeConfig.staticFolder}/images/Path.svg`} alt="Path" className="ml-sm-1" />
                                                </div>
                                        </Link>
                                    </div>
                                </ScrollAnimation>
                            </Col>
                            <Col className="text-center desktop">
                                <ScrollAnimation animation='bounceInRight'>
                                    <img src={`${publicRuntimeConfig.staticFolder}/images/ux-ui-sec.png`} alt="ux-ui-sec" className="mt-3 auto-width-c" />
                                </ScrollAnimation>
                            </Col>
                        </Row>
                    </div>
                </Container>
                <style>
                    {
                        `
                        body{
                            overflow-x: hidden
                        }
                        `
                    }
                </style>
            </section>
        )
    }
}
